import React from "react";
import EventCard from "./Potlucks/EventCard";

const GuestView = (props) => {
  
  return (
    <>
      <h2>Events you're invited to:</h2>
      <EventCard />
    </>
  );
};

export default GuestView;
